import "../styles/cards.scss";
import date from "../assets/img/archiveCalendar.png";
import { useNavigate } from "react-router-dom";

export function ArchiveCard(props) {
    const navigate = useNavigate();
    return (
        <div
            className="archiveCard"
            onClick={() => {
                navigate(props.link);
            }}
        >
            <img className="img" src={props.img} />
            <div className="data">
                <div className="set">
                    <img className="i1" src={date} />
                    <div className="date">{props.date}</div>
                </div>
            </div>
            <div className="title">{props.title}</div>
            <div className="text">{props.text}</div>
            <div className="other">
                <div className="rate">
                    <div className="star">&#9733;</div>
                    {props.rate}
                </div>
            </div>
        </div>
    );
}
